'use strict';

const Mn = require('backbone.marionette');
const Template = require('system/ui/template/mode-indicator/snapshot.hbs');
const TimeHelper = require('common/ui/template/helper/time');

module.exports = Mn.View.extend({
    tagName: 'div',
    className: 'indicator-container',
    template: Template,
    templateContext: function() {
        return {
            snapshotAt: TimeHelper(this.getOption('dt')),
            url: this.getOption('url')
        }
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/mode-indicator/snapshot.js